import { DefaultState } from '@src/redux/types'

import {
  LESSON,
  LESSON_ALL,
  LESSON_ASSESSMENT,
  LESSON_ASSESSMENT_ALL,
  LESSON_ASSESSMENT_LIST,
  LESSON_ATTENDANCE,
  LESSON_ATTENDANCE_GROUP,
  LESSON_CREATE,
  LESSON_DELETE,
  LESSON_DISTANCE_LEARNING_ALL,
  LESSON_DOWNLOAD_FILES,
  LESSON_HOMEWORK_UPLOAD,
  LESSON_LIST,
  LESSON_MARK_ASSESSMENT,
  LESSON_SORTING,
} from '../constants/actionTypes'
import * as API from '../constants/api'

export const defaultState = () => ({ loading: false, error: null, data: null })

export const initialState: () => {
  [LESSON]: DefaultState<`${typeof API.LESSON}{id}`, 'get'>
  [LESSON_ALL]: DefaultState<`${typeof API.LESSON_ALL}`, 'get'>
  [LESSON_ASSESSMENT]: DefaultState<`${typeof API.LESSON_ASSESSMENT}{id}`, 'get'>
  [LESSON_ASSESSMENT_ALL]: DefaultState<`${typeof API.LESSON_ASSESSMENT_ALL}`, 'get'>
  [LESSON_ASSESSMENT_LIST]: DefaultState<`${typeof API.LESSON_ASSESSMENT}`, 'get'>
  [LESSON_CREATE]: DefaultState<`${typeof API.LESSON}`, 'post'>
  [LESSON_DELETE]: DefaultState<`${typeof API.LESSON}{id}`, 'delete'>
  [LESSON_HOMEWORK_UPLOAD]: DefaultState<`${typeof API.LESSON_HOMEWORK_UPLOAD}`, 'post'>
  [LESSON_LIST]: DefaultState<`${typeof API.LESSON}`, 'get'>
  [LESSON_MARK_ASSESSMENT]: DefaultState<`${typeof API.LESSON_ASSESSMENT}`, 'post'>
  [LESSON_SORTING]: DefaultState<`${typeof API.LESSON_SORTING}`, 'put'>
  [LESSON_DOWNLOAD_FILES]: DefaultState<`${typeof API.LESSON_DOWNLOAD_FILES}`, 'get'>
  [LESSON_DISTANCE_LEARNING_ALL]: DefaultState<`${typeof API.LESSON_DISTANCE_LEARNING_ALL}`, 'get'>
  [LESSON_ATTENDANCE]: DefaultState<`${typeof API.LESSON_ATTENDANCE}`, 'get'>
  [LESSON_ATTENDANCE_GROUP]: DefaultState<`${typeof API.LESSON_ATTENDANCE_GROUP}`, 'get'>
} = () => ({
  [LESSON]: defaultState(),
  [LESSON_ALL]: defaultState(),
  [LESSON_ASSESSMENT]: defaultState(),
  [LESSON_ASSESSMENT_ALL]: defaultState(),
  [LESSON_ASSESSMENT_LIST]: defaultState(),
  [LESSON_CREATE]: defaultState(),
  [LESSON_DELETE]: defaultState(),
  [LESSON_HOMEWORK_UPLOAD]: defaultState(),
  [LESSON_LIST]: defaultState(),
  [LESSON_MARK_ASSESSMENT]: defaultState(),
  [LESSON_SORTING]: defaultState(),
  [LESSON_DOWNLOAD_FILES]: defaultState(),
  [LESSON_DISTANCE_LEARNING_ALL]: defaultState(),
  [LESSON_ATTENDANCE]: defaultState(),
  [LESSON_ATTENDANCE_GROUP]: defaultState(),
})
